<template lang="pug">
component.footer-logos__logo(:is="getTag" v-bind="getAttrs")
  img(v-if="logo.image" :src="logo.image" loading="lazy" :alt="'Logo' + logo.id")
</template>
<script>
export default {
  name: "FooterLogo",
  props: {
    logo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getTag() {
      if (this.logo.link) {
        return "a";
      }
      return "div";
    },
    getAttrs() {
      const attrs = {
        class: [`footer-logos__logo--${this.logo.id}`],
      };
      if (this.logo.link) {
        attrs.href = this.logo.link;
        attrs.target= "_blank";
      }
      return attrs;
    },
  },
}
</script>